import PropTypes from 'prop-types';
import { graphql } from 'gatsby';

import Page from '../../components/Page';
import FAQHeroBanner from '../../components/FAQ/FAQHeroBanner';
import FAQPaginatedAccordionV2 from '../../components/FAQ/FAQPaginatedAccordionV2';
import { WhiteBackground } from '../../components/Blog/styles';

const getFaqItems = (sections, id) => sections.find((section) => section.contentful_id === id)
  ?.combinatorSectionItems || [];

const FaqsPage = ({ data, itemsPerPage }) => {
  const { sections } = data.contentfulPage;

  const autoFaqs = getFaqItems(sections, '3FDVpp4mKMjyPybBhyO6tI');
  const homeFaqs = getFaqItems(sections, '6M15RzhUwHQTPsiBNJXqtu');
  const tenantFaqs = getFaqItems(sections, '5jVqCKBbpAcULLaM3F2yXb');
  const motorcycleFaqs = getFaqItems(sections, '3H0FbVyIvlq1X3BDf5W6CC');
  const generalFaqs = getFaqItems(sections, '5TGW3BJShfbhj0sKlh7uAI');
  const faqItems = [
    ...autoFaqs,
    ...homeFaqs,
    ...tenantFaqs,
    ...motorcycleFaqs,
    ...generalFaqs,
  ];

  const searchSection = sections.find(
    (section) => section.contentful_id === 'aiafuxIuHZvGBDFN4HB8U',
  );
  const categoryFilterSection = sections.find(
    (section) => section.contentful_id === '3SgbiNWVCGUVqOGLvBnzn',
  );
  const productFiltersSection = sections.find(
    (section) => section.contentful_id === '29znKbaliXGe4z2bOdX19s',
  );

  return (
    <Page data={data.contentfulPage}>
      <WhiteBackground>
        {sections.map((section) => {
          switch (section.contentful_id) {
            case '4MbLv6AnaZKqFbyV1kYn7O':
              return (
                <FAQHeroBanner
                  key={section.contentful_id}
                  data={section}
                  searchSection={searchSection}
                />
              );
            default:
              return null;
          }
        })}

        <FAQPaginatedAccordionV2
          itemsPerPage={itemsPerPage}
          categoryFilterSection={categoryFilterSection}
          productFiltersSection={productFiltersSection}
          faqItems={faqItems}
        />
      </WhiteBackground>
    </Page>
  );
};

FaqsPage.propTypes = {
  data: PropTypes.shape().isRequired,
  itemsPerPage: PropTypes.number,
};

FaqsPage.defaultProps = {
  itemsPerPage: 50,
};

export default FaqsPage;

export const query = graphql`
  query FaqsQuery($locale: String = "en-CA") {
    contentfulPage(
      contentful_id: { eq: "691gUKTeODoYXq7dsDw3ZB" }
      node_locale: { eq: $locale }
    ) {
      ...Page
      sections {
        ...IconCardsSection
        ...HeroBanner
        ...LinkSection
        ...CombinatorSection
        ...TextSection
      }
    }
  }
`;
